import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable()

@Pipe({
    name: 'pairs',
    standalone: true
})

export class PairsPipe implements PipeTransform {
  constructor() {}
  transform<V>(obj: Record<string, V>): [string, V][];
  transform(obj: any): any[];
  transform(obj: any): any[] {
    if (Array.isArray(obj) || !this.isObject(obj)) {
      return obj;
    }

    return Object.entries(obj);
  }

  isObject(value: any) {
    return value !== null && typeof value === 'object';
  }
}
